import { trackAbTastyEvent } from "~/lib/track-abtasty-event.client";

import { pushEvent } from "./gtm-sink";

/**
 * Multi-sink event layer — GA4 search event.
 *
 * `GA4_search` is a NET-NEW, GA4-named event — deliberately NOT the existing
 * container `search` event, which feeds the SFRA eligibility-list tags (emitting
 * that from Workers product search would mis-fire eligibility analytics). It
 * carries the GA4-standard `search_term` param. Martech adds the matching
 * container trigger separately, so this is fork-gated + dormant (no consumer)
 * until then. The always-on Segment search event is `Products Searched`
 * (page-events.ts) — this is just the GTM-fork half.
 *
 * Non-ecommerce, so it uses flushless `pushEvent` and carries no `ecommerce`.
 *
 * Design: docs/analytics-segment-first-event-layer.md
 */
export type SearchEvent = {
  event: "GA4_search";
  /** The executed query (GA4-standard `search_term`). */
  search_term: string;
};

export const buildSearchEvent = (searchTerm: string): SearchEvent => ({
  event: "GA4_search",
  search_term: searchTerm,
});

/** Emit `GA4_search` once per executed search query. */
export const emitSearch = (searchTerm: string): void => {
  pushEvent(buildSearchEvent(searchTerm));

  // AB Tasty Universal Collect EVENT hit (SFCC-12079) — mapping confirmed by
  // Vince Scarlata on the ticket.
  trackAbTastyEvent({ ec: "Action Tracking", ea: "search" });
};
